import { css } from '@emotion/react';

export const cssResetStyles = css`
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  font-weight: normal;
  letter-spacing: normal;
  margin: 0;
  padding: 0;
  text-transform: none;
`;

export const lineClampStyles = (lines = 1) => css`
  display: -webkit-box;
  -webkit-line-clamp: ${lines};
  -webkit-box-orient: vertical;
  line-clamp: ${lines};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
`;
